import { render, staticRenderFns } from "./setMarginCoin.vue?vue&type=template&id=4917ffb0&"
import script from "./setMarginCoin.vue?vue&type=script&lang=js&"
export * from "./setMarginCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports